export const state = {
  selectedIMEI: null,
  selectedMarker: null,
  markersLoaded: false,
  drawer: {
    active: false,
    entity: null
  },
  search: {
    bounding: false,
    filtered: []
  }
}

export type State = typeof state
